import React from "react";

const SvgGemini = (props) => {
  return (
    <svg
      viewBox="0 0 30.98 41.26"
      width="1em"
      height="1em"
      {...props}
    >
      <path
        d="M21.82 32.32V8.94c3.48-1.23 6.55-3.46 8.86-6.54a1.5 1.5 0 00-2.4-1.8c-3.06 4.08-7.72 6.42-12.79 6.42C10.42 7.02 5.76 4.68 2.7.6A1.5 1.5 0 00.3 2.4c2.16 2.88 5 5.02 8.2 6.29v23.88c-3.21 1.27-6.04 3.41-8.2 6.29a1.5 1.5 0 002.4 1.8c3.06-4.08 7.72-6.42 12.79-6.42 5.07 0 9.73 2.34 12.79 6.42.29.39.74.6 1.2.6a1.5 1.5 0 001.2-2.4c-2.31-3.08-5.38-5.31-8.86-6.54zm-10.32-.66V9.59c1.29.28 2.63.42 3.99.42 1.13 0 2.24-.1 3.33-.29v21.8c-1.09-.19-2.2-.29-3.33-.29-1.36.01-2.69.16-3.99.43z"
        fillRule="evenodd"
        clipRule="evenodd"
      />
    </svg>
  );
};

export default SvgGemini;
